import { HOST_QUERY_KEY, metaApiInstance } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { getServerTraceHttpTimingOptions } from '../../utils/serverTrace/store';

import type { ServiceAppState } from '@kc-console/context';
import type { Guard } from '../../types';

/**
 * 점검중인지를 체크하는 가드입니다.
 * @description
 * - 콘솔 점검 여부를 체크합니다.
 * - 점검 중인 경우 SERVICE_UNAVAILABLE(503) 상태를 반환합니다.
 */
export const checkMaintenanceGuard: Guard<ServiceAppState> = async ({ context, queryClient }) => {
  const { fetchConsoleConfig } = metaApiInstance({
    ...getServerTraceHttpTimingOptions(context.req, 'config'),
  });

  try {
    const { maintenance } = await queryClient.fetchQuery({
      queryKey: [HOST_QUERY_KEY.GET_CONSOLE_CONFIG],
      queryFn: fetchConsoleConfig,
    });

    if (maintenance) {
      return { status: STATUS_CODE.SERVICE_UNAVAILABLE };
    }
    return { status: STATUS_CODE.OK };
  } catch {
    return { status: STATUS_CODE.INTERNAL_SERVER_ERROR };
  }
};

checkMaintenanceGuard.displayName = 'checkMaintenanceGuard';
